// src/utils/firebase/fetchMeasurementVariantsPresence.js
import { fetchRegionalMeasurementPresence } from "../backend/pdxBackendClient";

/**
 * Checks, for each variant, whether the authenticated user has a measurement.
 *
 * The name is retained for compatibility with existing imports, but the data now
 * comes from the regional measurement service instead of direct Firestore reads.
 *
 * @param {object} args
 * @param {string} args.uid
 * @param {string[]} args.variants
 * @param {boolean} [args.requireCompleted=false]
 * @param {number|null} [args.recentWithinMs=null]
 * @returns {Promise<{ byVariant: Record<string, boolean>, any: boolean }>}
 */
export async function fetchMeasurementVariantsPresence({
  uid,
  variants,
  requireCompleted = false,
  recentWithinMs = null,
  fetchMeasurementPresence = fetchRegionalMeasurementPresence,
}) {
  if (!uid)
    throw new Error("fetchMeasurementVariantsPresence: uid is required");
  if (!Array.isArray(variants) || variants.length === 0)
    throw new Error("fetchMeasurementVariantsPresence: variants[] is required");

  return fetchMeasurementPresence({
    variants,
    requireCompleted,
    recentWithinMs,
  });
}
